import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import styles from './TheatreCreateNameForm.module.scss';
import { validation } from '../../../../../utils';
import EntityNameField from '../../../../common/components/UI/EntityNameField/EntityNameField';

function TheatreCreateNameForm({ onChangeName, refTitleName }) {
  return (
    <form className={styles.theaterNameForm}>
      <Field
        ref={refTitleName}
        withRef={true}
        name="name"
        type="text"
        isFocusAfterMounted={true}
        component={EntityNameField}
        className={styles.input}
        placeholder="Enter screen name"
        validate={[validation.required, validation.isSpaceChar]}
        onChange={onChangeName}
        normalize={validation.normalizeExtraSpaces}
      />
    </form>
  );
}

TheatreCreateNameForm.propTypes = {
  refTitleName: PropTypes.shape({ current: PropTypes.object }),
  onChangeName: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'createTheatreName',
  enableReinitialize: true,
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: false,
})(TheatreCreateNameForm);
